// ============================================
// 공통 Label/Color 유틸리티
// 사건, 시료, 분석 상태/유형의 한글 라벨 및 색상 정의
// ============================================

// --- Case ---

export const caseTypeLabels: Record<string, string> = {
  fire: "화재",
  arson: "방화",
  terror: "테러",
  leak: "가스누출",
  death: "사망",
  other: "기타",
};

export const caseTypeColor = (type: string) => {
  switch (type) {
    case "fire":
      return "text-red-700 bg-red-100";
    case "arson":
      return "text-orange-700 bg-orange-100";
    case "terror":
      return "text-purple-700 bg-purple-100";
    case "leak":
      return "text-cyan-700 bg-cyan-100";
    case "death":
      return "text-gray-700 bg-gray-100";
    default:
      return "text-gray-700 bg-gray-100";
  }
};

export const caseStatusLabels: Record<string, string> = {
  open: "접수",
  in_progress: "진행중",
  pending: "보류",
  closed: "종결",
};

export const caseStatusColor = (status: string) => {
  switch (status) {
    case "open":
      return "text-blue-700 bg-blue-100";
    case "in_progress":
      return "text-yellow-700 bg-yellow-100";
    case "closed":
      return "text-green-700 bg-green-100";
    default:
      return "text-gray-700 bg-gray-100";
  }
};

// --- Sample ---

export const sampleTypeLabels: Record<string, string> = {
  gcms: "GC-MS",
  ftir: "FTIR",
  mixed: "혼합",
};

export const sampleStatusLabels: Record<string, string> = {
  registered: "등록",
  uploaded: "업로드",
  analyzing: "분석중",
  analyzed: "분석완료",
  failed: "실패",
};

export const sampleStatusColor = (status: string) => {
  switch (status) {
    case "registered":
      return "text-gray-700 bg-gray-100";
    case "uploaded":
      return "text-blue-700 bg-blue-100";
    case "analyzing":
      return "text-yellow-700 bg-yellow-100";
    case "analyzed":
      return "text-green-700 bg-green-100";
    case "failed":
      return "text-red-700 bg-red-100";
    default:
      return "text-gray-700 bg-gray-100";
  }
};

// --- Analysis ---

export const analysisTypeLabels: Record<string, string> = {
  pattern_matching: "패턴 매칭",
  compound_inference: "화합물 추론",
  hazard_assessment: "위험성 평가",
  full_analysis: "전체 분석",
};

export const analysisStatusLabels: Record<string, string> = {
  pending: "대기",
  running: "실행중",
  completed: "완료",
  failed: "실패",
};

export const analysisStatusColor = (status: string) => {
  switch (status) {
    case "pending":
      return "text-gray-700 bg-gray-100";
    case "running":
      return "text-yellow-700 bg-yellow-100";
    case "completed":
      return "text-green-700 bg-green-100";
    case "failed":
      return "text-red-700 bg-red-100";
    default:
      return "text-gray-700 bg-gray-100";
  }
};
